import { render } from "./referencias.vue?vue&type=template&id=0e8e7d6c&scoped=true"
import script from "./referencias.vue?vue&type=script&lang=js"
export * from "./referencias.vue?vue&type=script&lang=js"

import "./referencias.vue?vue&type=style&index=0&id=0e8e7d6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8e7d6c"]])

export default __exports__